module.exports = __webpack_public_path__ + "img/DAVID_CANNON_30-rs.35be6595.jpg";